import React from 'react';
import PropTypes from 'prop-types';
import { getTokensPropType, useThemeTokens } from '@telus-uds/components-base';
import { jsx as _jsx } from "react/jsx-runtime";
const withClientTheme = Component => {
  const UdsStyledComponent = _ref => {
    let {
      tokens: tokenOverrides,
      variant,
      ...props
    } = _ref;
    const theme = useThemeTokens(Component.displayName, tokenOverrides, variant);
    return /*#__PURE__*/_jsx(Component, {
      theme: theme,
      ...props
    });
  };
  UdsStyledComponent.propTypes = {
    tokens: getTokensPropType(Component.displayName),
    variant: PropTypes.string
  };
  return UdsStyledComponent;
};
export default withClientTheme;